module.exports = __webpack_public_path__ + "img/ex-blog-post.b8f68869.jpg";